export const formatMetaExpressionForBackend = (metaExpr: any) => {
  delete metaExpr.currentStep;
  delete metaExpr.useDefaultFields;
  delete metaExpr.useSecondDefaultFields;
  delete metaExpr.subscope;
  delete metaExpr.stepRessourceId;
  return metaExpr;
};
